// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
// components
import { Stack, Typography } from '@lyearn/ui';

// types
import { OptionItemProps } from '../OptionItem/types';
import Tag from '../Tag';

const AddOptionItem = (props: OptionItemProps) => {
  const { t } = useTranslation();
  const { option } = props;

  return (
    <Stack alignItems="center" className="max-w-full">
      <Typography
        className="flex-shrink-0 me-6"
        color="text-text-paragraph"
        variant="body-short-02">
        {t('Common:Actions.Add')}
      </Typography>
      <Tag option={option} />
    </Stack>
  );
};

export default AddOptionItem;
